let _Math = require("../lib/Math");

class PlotYAxis extends React.Component {
  componentDidMount() {
    this.plot();
  }

  componentDidUpdate() {
    this.plot();
  }

  plot() {
    let { scaleY, formatY, domainY, typeY, width } = this.props;

    let yNode = d3.select(this.refs.axis);

    let yAxis = d3.axisLeft()
      .scale(scaleY)
      .tickSizeInner(width)
      .tickFormat(formatY); // may be null

    if (typeY === "ordinal") {
      yAxis.tickValues(domainY);
    }
    else {
      yAxis.tickValues(domainY.ticks); // may be null
    }

    yNode.call(yAxis);
  }

  render() {
    let { width, height, margin, label } = this.props;

    return (
      <g className="mc-plot-y-axis">
        <text x={height / -2} y={10 - margin.left} transform="rotate(-90)" textAnchor="middle">
          {label}
        </text>
        <g transform={`translate(${width})`} ref="axis"/>
      </g>
    );
  }
}

module.exports = PlotYAxis;
